import { SsoSetupServiceImpl } from "~/backend/generated/SSOSetup/api/ssoSetup.service";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";
import { getEnvironmentConfig } from "~/modules/config";
import { assertDefined, assertObject } from "~/utils/assert";
import { mapRootKeysToCamelCase } from "~/utils/mapKeys";
import { getRuntimeDomainName } from "../AuthenticatorHelpers/getRuntimeDomainName";
import type { AuthenticationConfigParams, AuthenticationConfig, AuthenticationConfigResponse } from "./types";

export const getAuthenticationConfig = async (
    config: AuthenticationConfigParams
): Promise<AuthenticationConfigResponse> => {
    const ctx = ContextManager.newInstance();
    assertDefined<AuthenticationConfigParams>(config, "config");
    assertObject<AuthenticationConfigParams>(config, "config");
    const ssoSetupService = ctx.retrieveInstanceOf(ContextInstance.SsoSetupServiceImpl, SsoSetupServiceImpl);

    const {
        accountSid = "",
        instanceSid = "",
        runtimeDomain = "",
        ssoProfileSid = "",
        appType = "SinglePageApp"
    } = config;

    let runtimeDomainUrl = runtimeDomain;
    if (runtimeDomain) {
        const environmentConfig = getEnvironmentConfig();
        const { region } = environmentConfig || {};
        runtimeDomainUrl = getRuntimeDomainName(runtimeDomain, region);
    }

    const response = await ssoSetupService.getAuthenticationConfig(
        accountSid,
        instanceSid,
        runtimeDomainUrl,
        ssoProfileSid,
        appType
    );
    const configList = response?.configList || [];
    return {
        configList: configList.map((item) => mapRootKeysToCamelCase(item) as AuthenticationConfig)
    };
};
